import { getUserProfile } from '../redux/actions/ProfileActions';
import { getRegions } from '../redux/actions/RegionsActions';
import { callLogoutUser } from '../services/AuthenticationService';
import { getUserCategory } from '../redux/actions/LoyaltyActions';

import { deleteCookie } from '../providers/Cookies';
import getTokens from '../providers/getTokens';
import { showPointsInSideBar } from './BankHelper';
import { getCustomerPoints } from '../redux/actions/BankActions';
import { simpleUrl } from '../config/paths';

export const userAuthenticationProcess = () => async (dispatch) => {
  const wcToken = getTokens().wcToken();
  const wcAuthenticationToken = getTokens().wcTrustedToken();
  const response = await dispatch(
    getUserProfile(wcToken, wcAuthenticationToken),
  );
  if (response?.success) {
    dispatch(getRegions());
    dispatch(getUserCategory());
    if (showPointsInSideBar()) dispatch(getCustomerPoints());
  }
};

export const goOut = async () => {
  const wcToken = getTokens().wcToken();
  const wcAuthenticationToken = getTokens().wcTrustedToken();
  if (wcToken && wcAuthenticationToken) await callLogoutUser();
  removeCookies();
  window.location.href = simpleUrl;
};

export const removeCookies = () => {
  const cookieArray = document.cookie.split(';');
  cookieArray.forEach((cookie) => {
    const cookieName = cookie.split('=')[0].trim();
    deleteCookie(cookieName);
  });
};
